import { render } from "./SellerGroupList.vue?vue&type=template&id=f350a850"
import script from "./SellerGroupList.vue?vue&type=script&lang=js"
export * from "./SellerGroupList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__